import React from 'react';
import * as motion from 'motion/react-client';

const ANIMATION_DURATION = 0.6;

type CenterBlurOverlayProps = {
  expandedSection: 'left' | 'right' | null;
};

const CenterBlurOverlay = ({ expandedSection }: CenterBlurOverlayProps) => {
  const getPosition = () => {
    if (expandedSection === null) {
      return '50%';
    }
    if (expandedSection === 'left') {
      return '100%';
    } else if (expandedSection === 'right') {
      return '0%';
    }
    return '50%';
  };

  return (
    <motion.div
      className="absolute top-1/2 left-1/2 h-full w-fit -translate-x-1/2 -translate-y-1/2 flex z-[2] pointer-events-none"
      animate={{ left: getPosition() }}
      transition={{ duration: ANIMATION_DURATION, ease: 'easeInOut' }}
    >
      <motion.div
        className="w-[182px] h-full"
        style={{ background: 'linear-gradient(90deg, rgba(15, 15, 15, 0) 0%, #0f0f0f 100%)' }}
        animate={{
          opacity: expandedSection === 'right' ? 0 : 1,
        }}
      />
      <motion.div
        className="w-[182px] h-full"
        style={{ background: 'linear-gradient(to left, rgba(255, 255, 255, 0) 0%, #fff 100%)' }}
        animate={{
          opacity: expandedSection === 'left' ? 0 : 1,
        }}
      />
    </motion.div>
  );
};

export default CenterBlurOverlay;
